/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, provider: NonNullable<unknown> }} Partner_Connectors_Remove_DescriptionInputs */



/**
* | output |
* | --- |
* | "{count} spaces use {provider}. They stay, but cannot sync or be opened until a package for {provider} is installed again." |
*
* @param {Partner_Connectors_Remove_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_connectors_remove_description = /** @type {((inputs: Partner_Connectors_Remove_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Connectors_Remove_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Spaces nutzen ${i?.provider}. Sie bleiben erhalten, können aber weder synchronisiert noch geöffnet werden, bis wieder ein Paket für ${i?.provider} installiert ist.`)
	return /** @type {LocalizedString} */ (`${i?.count} spaces use ${i?.provider}. They stay, but cannot sync or be opened until a package for ${i?.provider} is installed again.`)
});